import React from "react";
import { Grid, TextField } from "@mui/material";
import { Field } from "formik";

export default function ProductBasicFields({ errors, touched }) {
  return (
    <>
      <Grid item xs={12}>
        <Field
          as={TextField}
          name="name"
          label="שם המוצר"
          required
          fullWidth
          helperText={touched.name && errors.name ? errors.name : ""}
          error={touched.name && Boolean(errors.name)}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          as={TextField}
          name="price"
          label="מחיר"
          type="number"
          required
          fullWidth
          helperText={touched.price && errors.price ? errors.price : ""}
          error={touched.price && Boolean(errors.price)}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          as={TextField}
          name="quantity"
          label="כמות במלאי"
          required
          fullWidth
          helperText={touched.quantity && errors.quantity ? errors.quantity : ""}
          error={touched.quantity && Boolean(errors.quantity)}
        />
      </Grid>

      <Grid item xs={12}>
        <Field
          as={TextField}
          name="description"
          label="תיאור"
          multiline
          rows={4}
          fullWidth
          helperText={touched.description && errors.description ? errors.description : ""}
          error={touched.description && Boolean(errors.description)}
        />
      </Grid>
    </>
  );
}
